import styled from "styled-components";

const TextArea = styled.textarea``;

export default TextArea;
